export const getMasterConfig = (masters, BMS_ID) => {
    if (!masters) return null;
    return masters?.find((master) => master.MASTER_SN === BMS_ID);
};

export const getPackConfig = (packs, moduleID) => {
    if (!packs) return null;
    return packs.find((packs) => packs.PACK_SN === moduleID);
};
